import React from "react";
import "./qualifications.scss";

// components
import Wrapper from "../../layouts/wrapper/Wrapper";
import CommonHeader from "../../common/commonHeader/CommonHeader";

// data
import { qualificationsData } from "../../../assets/data/qualificationsData";
import { experienceData } from "../../../assets/data/qualificationsData";
import LayoutAnimations from "../../animations/LayoutAnimations";

const Qualifications = () => {
  return (
    <section id="portfolio">
      <Wrapper>
        <section className="qualifications">
          <CommonHeader
            title="Qualifications"
            subtitle="Our CEO Qualifications"
            bgText="Academic Qualifications"
            center={true}
          />

          <div className="qualifications__container">
            <LayoutAnimations propVarient={"leftToRight"}>
              <div className="qualifications__eduAndExp">
                <div className="eduAndEx__title">
                  <i className="fas fa-graduation-cap"></i>
                  <h2 className="edu__title">Education</h2>
                </div>

                {qualificationsData.map((item, index) => (
                  <div className="eduAndExp__item" key={index}>
                    <h3 className="eduAndExp__itemtitle">{item?.title}</h3>

                    <div className="eduAndExp__itemdateicon">
                      <i className="fas fa-calendar-alt"></i>
                      <span className="eduAndExp__itemdate">{item?.date}</span>
                    </div>

                    <span className="eduAndExp__itemplace">
                      {item?.institute}
                    </span>
                  </div>
                ))}
              </div>
            </LayoutAnimations>

            <LayoutAnimations propVarient={"rightToLeft"}>
              <div className="qualifications__eduAndExp">
                <div className="eduAndEx__title">
                  <i className="fas fa-briefcase"></i>
                  <h2 className="edu__title">Experience</h2>
                </div>

                {experienceData.map((item, index) => (
                  <div className="eduAndExp__item" key={index}>
                    <h3 className="eduAndExp__itemtitle">{item?.title}</h3>

                    <div className="eduAndExp__itemdateicon">
                      <i className="fas fa-calendar-alt"></i>
                      <span className="eduAndExp__itemdate">{item?.date}</span>
                    </div>

                    <span className="eduAndExp__itemplace">
                      {item?.institute}
                    </span>
                  </div>
                ))}
              </div>
            </LayoutAnimations>
          </div>
        </section>
      </Wrapper>
    </section>
  );
};

export default Qualifications;
